<div class="wrapper">
  <div class="circle"></div>
  <div class="circle"></div>
  <div class="circle"></div>
  <div class="shadow"></div>
  <div class="shadow"></div>
  <div class="shadow"></div>
</div>

<style>
  .wrapper {
    width: 100px;
    height: 45px;
    position: relative;
    z-index: 1;
    margin: 0 auto;
  }

  .circle {
    width: 15px;
    height: 15px;
    position: absolute;
    border-radius: 50%;
    background-color: var(--orange);
    left: 15%;
    transform-origin: 50%;
    animation: circleBouncing 500ms alternate infinite ease;
  }

  @keyframes circleBouncing {
    0% {
      top: 40px;
      height: 5px;
      border-radius: 50px 50px 25px 25px;
      transform: scaleX(1.7);
    }

    40% {
      height: 20px;
      border-radius: 50%;
      transform: scaleX(1);
    }

    100% {
      top: 0%;
    }
  }

  .circle:nth-child(2) {
    left: 45%;
    animation-delay: 200ms;
  }

  .circle:nth-child(3) {
    left: auto;
    right: 15%;
    animation-delay: 300ms;
  }

  .shadow {
    width: 15px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 62px;
    transform-origin: 50%;
    z-index: -1;
    left: 15%;
    filter: blur(1px);
    animation: shadowBouncing 500ms alternate infinite ease;
  }

  @keyframes shadowBouncing {
    0% {
      transform: scaleX(1.5);
    }

    40% {
      transform: scaleX(1);
      opacity: 0.7;
    }

    100% {
      transform: scaleX(0.2);
      opacity: 0.4;
    }
  }

  .shadow:nth-child(4) {
    left: 45%;
    animation-delay: 200ms;
  }

  .shadow:nth-child(5) {
    left: auto;
    right: 15%;
    animation-delay: 300ms;
  }
</style>
